import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useShadowBanMemberMutation = createMutationHook(
  MembershipsCreatorApiClient.shadowBanMember,
  {
    mutationKey: ['shadowBanMember'],
  },
)
